import React from 'react'

import { Row, Text, Box, Heading } from './styled'

const SectionBanner = ({ children, title = '', color = 'gray2', ...props }) => {
  const header = (
    <Heading.h2
      textAlign={['center', 'center', 'left']}
      mb={['2.5rem', 0]}
      id={title.toLowerCase()}
    >
      {title}
    </Heading.h2>
  )

  if (children) {
    return (
      <Row
        flexDirection={['column', 'row']}
        justifyContent="space-between"
        mb={7}
        {...props}
      >
        {header}
        <Box width={['100%', '50%']}>
          <Text.p color={color}>{children}</Text.p>
        </Box>
      </Row>
    )
  }

  return (
    <Row
      flexDirection={['column', 'column', 'row']}
      mb={[0, 7]}
      width="100%"
      {...props}
    >
      {header}
    </Row>
  )
}

export default SectionBanner
